import { Box, Button, Grid, IconButton, TextField, Typography } from '@mui/material'
import React from 'react'
import { FaFacebookF } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import { IoIosSend } from "react-icons/io";
import { Link } from 'react-router-dom';
import './style.css'
import { useAuthContext } from '../../Context/AuthContext';

function Footer() {
    const { menu, setMenu } = useAuthContext()
    return (
        <Box sx={{ height: 'auto', bgcolor: 'black', color: 'white', mt: 2 }}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3} lg={3}>
                    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', }} >
                        <Box sx={{ m: 3, px: 1 }}>
                            <Typography sx={{ fontSize: 18, textTransform: 'uppercase' }}>About</Typography>
                            {/* <Typography sx={{ fontSize: 12, my: 1 }}>
                                SDHR Innoworks Private Limited is a technology-driven company specializing in innovative software solutions, web development, mobile application development, and digital transformation services. We are committed to delivering high-quality, scalable, and reliable solutions tailored to meet the unique needs of businesses across various industries. With a focus on innovation, customer satisfaction, and technical excellence, SDHR Innoworks Pvt. Ltd. helps organizations streamline operations, enhance their digital presence, and achieve sustainable growth.
                                Business Hours: 9:00 AM – 8:00 PM (All Days)
                            </Typography> */}
                            {/* <Typography sx={{ fontSize: 12, my: 1 }}>
                                Jamshedpur Cane Furniture is a natural cane  manufacturer of outdoor furniture and accessories enter the world of Jamshedpur Cane Furniture'
                                Jamshedpur Cane Furniture have been manufacturing German outdoor furniture having exp in this field for 15 years.
                                we are Top Outdoor Furniture Manufacturers in Jamshedpur.
                                Timing - 9Am-8Pm ( All Days)
                            </Typography> */}
                            {<Typography sx={{ fontSize: 12, my: 1 }}>
                                SDHR Innoworks Private Limited is a natural cane  manufacturer of outdoor furniture and accessories enter the world of SDHR Innoworks Private Limited'
                                SDHR Innoworks Private Limited have been manufacturing German outdoor furniture having exp in this field for 15 years.
                                we are Top Outdoor Furniture Manufacturers in Tirupati Andhara Pradesh.
                                Timing - 9Am-8Pm ( All Days)
                            </Typography>}

                            <Box sx={{ color: 'white', justifyContent: 'space-evenly', display: 'flex', mt: 1 }}>
                                <IconButton sx={{ ":hover": { bgcolor: '#f5b600' } }}><FaFacebookF color='white' /></IconButton>
                                <IconButton sx={{ ":hover": { bgcolor: '#f5b600' } }}><FaWhatsapp color='white' /></IconButton>
                                <IconButton sx={{ ":hover": { bgcolor: '#f5b600' } }}><FaLinkedinIn color='white' /></IconButton>
                                <IconButton sx={{ ":hover": { bgcolor: '#f5b600' } }}><FaXTwitter color='white' /></IconButton>
                            </Box>
                        </Box>
                    </Box>

                </Grid>

                <Grid item xs={12} sm={6} md={3} lg={3}>
                    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', }} >
                        <Box sx={{ m: 3, px: 1, display: 'flex', flexDirection: 'column' }}>
                            {/* <Typography sx={{ fontSize: 18, textTransform: 'uppercase' }}>information</Typography> */}
                            <Typography sx={{ fontSize: 18, textTransform: 'uppercase' }}>Developed & Maintained By</Typography>
                            {/* <Link to={'/'} className='links' onClick={() => setMenu({ title: 'Home', active: 0 })} ><Typography sx={{ fontSize: 14, my: 1 }} >Home </Typography></Link>
                            <Link to={'/Products'} className='links' onClick={() => setMenu({ title: 'Products', active: 1 })} ><Typography sx={{ fontSize: 14, my: 1 }}>Product</Typography></Link>
                            <Link to={'/Contact Us'} className='links' onClick={() => setMenu({ title: 'Contact Us', active: 2 })} ><Typography sx={{ fontSize: 14, my: 1 }}>Contact Us</Typography></Link>
                            <Link to={'/About Us'} className='links' onClick={() => setMenu({ title: 'About Us', active: 3 })} ><Typography sx={{ fontSize: 14, my: 1 }}>About Us</Typography></Link> */}
                            <Box sx={{ borderTop: "1px solid rgba(255,255,255,0.2)", mt: 3, py: 2, px: 2, /* textAlign: "center", */ color: "white", }}>
                                {/* <Typography variant="body2">© {new Date().getFullYear()} SDHR Innoworks Private Limited. All Rights Reserved.</Typography> */}

                                {/* <Typography variant="body2" sx={{ mt: 1 }}>Website Developed & Maintained By</Typography> */}
                                <Typography variant="body2" sx={{ fontWeight: "bold" }}>Name: Ashwani Kumar</Typography>
                                <Typography variant="body2" sx={{ fontWeight: "bold" }}>Company Name: AKITJSR</Typography>
                                <Typography variant="body2">Contact: +91 7349859978</Typography>
                                {/* <Typography variant="body2">✉️ sdhrinnoworks@gmail.com</Typography> */}
                            </Box>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={3}>
                    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', }} >
                        <Box sx={{ m: 3, px: 1, display: 'flex', flexDirection: 'column' }}>
                            <Typography sx={{ fontSize: 18, textTransform: 'uppercase' }}>Company</Typography>
                            {/* <Link to={'/'} className='links' ><Typography sx={{ fontSize: 14, my: 1 }}>Login </Typography></Link>
                            <Link to={'/'} className='links' ><Typography sx={{ fontSize: 14, my: 1 }}>Wishlist</Typography></Link>
                            <Link to={'/'} className='links' ><Typography sx={{ fontSize: 14, my: 1 }}>My Account</Typography></Link> */}
                            <Link to={'/'} className='links' ><Typography sx={{ fontSize: 14, my: 1 }}>Email: sdhrinnorworks@gmail.com</Typography></Link>
                            <Link to={'/'} className='links' ><Typography sx={{ fontSize: 14, my: 1 }}>Mobile. No.: +91 9347566010</Typography></Link>
                            <Link to={'/'} className='links' ><Typography sx={{ fontSize: 14, my: 1 }}>Company Name: SDHR InnoWorks Private Limited</Typography></Link>
                            <Link to={'/'} className='links' ><Typography sx={{ fontSize: 14, my: 1 }}>Address: 9/25/1 K K GUNTA, YERPEDU, Thondamanadu, Srikalahasti, Chittoor - 517641, Andhra Pradesh</Typography></Link>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={3}>
                    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', }} >
                        <Box sx={{ m: 3, px: 1, display: 'flex', flexDirection: 'column' }}>
                            <Typography sx={{ fontSize: 18, textTransform: 'uppercase' }}>news letter</Typography>

                            {/* <TextField type="text" id="outlined-basic" label="Primary Approver" variant="outlined" name="classRoom" value={schoolClass.classRoom} sx={{ my: 1, mt: 2, background: 'black', color: 'white', borderRadius: 1 }} placeholder='Primary Name' onChange={handleOnChange} error={valSchoolClass.classRoom ? true : false} fullWidth required /> */}
                            <TextField
                                type="email"
                                id="outlined-basic"
                                label="Email"
                                variant="outlined"
                                name="classRoom"
                                sx={{
                                    my: 1,
                                    mt: 2,
                                    background: 'black',
                                    borderRadius: 1,
                                    input: {
                                        color: 'white', // Text color
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: 'white', // Default border color
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#f5b600', // Border color on hover
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#f5b600', // Border color when focused
                                        },
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: 'white', // Default label color
                                    },
                                    '& .MuiInputLabel-root.Mui-focused': {
                                        color: '#f5b600', // Label color when focused
                                    },
                                }}
                                placeholder="Email"
                                fullWidth
                                required
                            />

                            <Button variant="outlined" sx={{
                                my: 2,
                                color: 'white', // Text color
                                borderColor: 'white', // Default border color
                                '&:hover': {
                                    borderColor: '#f5b600', // Border color on hover
                                    backgroundColor: '#f5b600', // Background color on hover
                                    color: 'white', // Text color on hover
                                },
                                '&.Mui-focused': {
                                    borderColor: '#f5b600', // Border color when focused
                                },
                            }}
                                startIcon={<IoIosSend />}
                            >
                                Send
                            </Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <Box sx={{ borderTop: "1px solid rgba(255,255,255,0.2)", py: 2, mt: 2, textAlign: "center", }}>
                <Typography sx={{ fontSize: 14, color: "white", }}>© {new Date().getFullYear()} SDHR Innoworks Private Limited. All Rights Reserved.</Typography>
            </Box>
        </Box>
    )
}

export default Footer